// deps
import React, { ReactElement, memo } from "react";

// internal deps
import { isEmpty } from "@swiggy-private/payment-core";

// components
import PaymentGroupTitle from "@payment-ui/components/payment-group/components/Title";
import PaymentGroupContainer from "@payment-ui/components/payment-group/components/Container";
import { FlipkartSuperCoinPaymentMethod } from "@payment-ui/components/payment-method/flipkart-super-coins";

// helpers
import {
    getPaymentMethods,
    isPaymentMethodSelected,
    generatePaymentMethodId,
    getPaymentGroupDisplayName,
    isPaymentGroupEnabled,
    getPaymentGroupDisableMessage,
    getPaymentGroupIconUrl,
} from "@payment-ui/helpers/Payment";

// interfaces
import { FlipkartSuperCoinsPaymentGroup } from "@payment-ui/interfaces";

// test-ids
import { PAYMENT_GROUP_TEST_IDS } from "@swiggy-private/payment-test-ids";
import styles from "../PaymentGroup.v4.scss";

function FlipkartSuperCoinsPG(props: FlipkartSuperCoinsPaymentGroup): ReactElement | null {
    const paymentMethods = getPaymentMethods(props);
    const isGroupEnabled = isPaymentGroupEnabled(props.paymentData);

    if (isEmpty(paymentMethods)) {
        return null;
    }

    return (
        <PaymentGroupContainer>
            {!props.hideGroupTitle && (
                <PaymentGroupTitle
                    title={getPaymentGroupDisplayName(props.paymentData)}
                    disableMessage={getPaymentGroupDisableMessage(props.paymentData)}
                    data-testid={PAYMENT_GROUP_TEST_IDS.TITLE.FLIPKART_SUPER_COINS}
                    groupIcon={getPaymentGroupIconUrl(props.paymentData)}
                />
            )}
            <div className={styles.paymentGroupContainer}>
                {paymentMethods.map(paymentMethod => {
                    const id = generatePaymentMethodId(paymentMethod);
                    return (
                        <FlipkartSuperCoinPaymentMethod
                            id={id}
                            key={paymentMethod.name}
                            methodData={paymentMethod}
                            paymentActions={props.paymentActions}
                            paymentAmount={props.paymentAmount}
                            isPaymentGroupEnabled={isGroupEnabled}
                            selected={isPaymentMethodSelected(props.selectedPaymentId, id)}
                            onFlipkartToolTipShow={props.onFlipkartToolTipShow}
                        />
                    );
                })}
            </div>
        </PaymentGroupContainer>
    );
}

export default memo(FlipkartSuperCoinsPG);
